import { put, call, take, fork } from 'redux-saga/effects'
import { deleteSectionService } from '../../api/card'
import { DELETE_SECTION } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* selectionDeleteFlow(payload) {
  try {
    const { id, callback } = payload
    yield call(deleteSectionService, id)

    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* selectionDeleteWatcher() {
  while (true) {
    const action = yield take(DELETE_SECTION)
    const { payload } = action

    yield fork(generalSaga, selectionDeleteFlow, payload)
  }
}
